import {href} from 'react-router';

import {getLanguage} from '@/shared/services/i18n';

const localizeHref = new Proxy(href, {
  apply(target, thisArg, [path, params]: [string, object?]) {
    const curLang = getLanguage();

    if (curLang === 'en') {
      return Reflect.apply(target, thisArg, [path, params]);
    }

    // Spread last, so an explicit `lang` still wins.
    return Reflect.apply(target, thisArg, [path, {lang: curLang, ...params}]);
  },
});

export {localizeHref};
